import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Typography,
  Box,
  Divider,
  Toolbar,
  CssBaseline,
  Tooltip,
} from "@mui/material";
import { styled, useTheme } from "@mui/material/styles";
import MuiAppBar from "@mui/material/AppBar";
import MenuIcon from "@mui/icons-material/Menu";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import CloseIcon from "@mui/icons-material/Close";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import AssessmentIcon from "@mui/icons-material/Assessment";
import Collapse from "@mui/material/Collapse";
import Link from "@mui/material/Link";
import logo from "../../../images/logoBrancoPrincipal.png";
import { useNavigate } from "react-router-dom";
import StepsGeneric from "../../../components/StepsGeneric";
import TabsGeneric from "../../../components/TabsGeneric";
import GerarRelatorioCompleto from "./StepsAnalisar/GerarRelatorioCompleto";
import VerbasEsocial from "./StepsAnalisar/VerbasEsocial/VerbasEsocial";
import AjustesVerbas from "./StepsAnalisar/AjusteVerbas";
import Impostos from "./StepsAnalisar/Impostos";
import Relatorio20s from "./StepsAnalisar/Relatorio20s";
import ModalEditar from "../ModalEditar";
import SnackBar from "../../../components/SnackBar";
import TableCardv2 from "../../../components/TableCardv2";
import BasicSelect from "../../../components/BasicSelect";
import { useContext, useEffect, useMemo, useState, useRef } from "react";
import styles from "./styes.module.css";
import ModalVisualizarPreviaPDF from "../ModalPreviaPDF";
import { buscarCategoriasTributarias } from "../../../services/api-planejamento-tributario.service";
import {
  salvartVinculoCategoriaVerba,
  buscarVerbasComCategorias,
  gerarRelatorioPreviaInssConsolidado,
  gerarRelatorioProjetoInssConsolidado,
  enviarProjetoInss,
} from "../../../services/api-inss.service";
import { buscarComboPorCodigo } from "../../../services/auth.service";
import { listarEmpresas } from "../../../services/api-empresas.service";
import { PreviaInssContext } from "../PreviaInssContext";

const STORAGE_STEP_KEY = "previa_inss_active_step";

const drawerWidth = 240;

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
  justifyContent: "flex-end",
}));

const MainComponente = ({ tabComponent, data, rechargeData, closeModal, gerarProjetoFlow = false }) => {
  const initialInfoeHeader = {
    dtAbertura: "00/00/00",
    dtOptionSimples: "00/00/00",
    dtExclusaoSImples: "00/00/00",
  };

  const theme = useTheme();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [menuItems, setMenuItems] = useState([]);
  const [openMenus, setOpenMenus] = useState([]);
  const [modalEditar, setModalEditar] = useState(false);
  const [dadosModalEditar, setDadosModalEditar] = useState({});
  const [activeStep, setActiveStep] = useState(() => {
    const v = Number(sessionStorage.getItem(STORAGE_STEP_KEY));
    return Number.isInteger(v) && v >= 0 ? v : 0;
  });
  useEffect(() => {
    sessionStorage.setItem(STORAGE_STEP_KEY, String(activeStep));
  }, [activeStep]);

  const [categorias, setCategorias] = useState([]);
  const [infoHeader, setInfoHeader] = useState(initialInfoeHeader);
  const [objSnackBar, setObjSnackBar] = useState({ type: "", msg: "" });
  const [dadosPreviaPDF, setDadosPreviaPDF] = useState([]);
  const { setLoading, loadingVersao, handleBuscarResumoGeralVersao } = useContext(PreviaInssContext);
  const { dados } = useContext(PreviaInssContext);
  const [verbasPendentes, setVerbasPendentes] = useState([]);
  const [modalVerbasPendentes, setModalVerbasPendentes] = useState(false);
  const [categoriasVerbas, setCategoriasVerbas] = useState([]);
  const [payloadVerbas, setPayloadVerbas] = useState([]);
  const verbasPayloadRef = useRef([]);
  const verbasMockadasRef = useRef(null);
  const modalRef = useRef();

  const [modalFlow, setModalFlow] = useState("previa"); // 'previa' | 'projeto'

  const formatData = (date) => {
    if (!date) return "------";
    const str = String(date);
    const parts = str.split("-");
    if (parts.length < 3) return str;
    const day = (parts[2] || "").split("T")[0] || parts[2];
    return `${day}/${parts[1]}/${parts[0]}`;
  };

  useEffect(() => {
    const fetchCategoriasViaCombo = async () => {
      try {
        const response = await buscarComboPorCodigo("ESOCIALVERBAS");
        const lista = response?.detalhes?.itensCombo || [];
        const categorias = lista.map((item) => {
          const [id, descricao] = item.split("/|/");
          return { id: Number(id), descricao };
        });
        setCategoriasVerbas(categorias);
      } catch (error) {
        console.error("❌ Erro ao buscar combo ESOCIALVERBAS:", error);
      }
    };
    fetchCategoriasViaCombo();
  }, []);

  const prevDadosPreviaPDFRef = useRef(null);
  const shouldOpenModalRef = useRef(false);
  
  /**
   * Regras de abertura do modal PDF:
   * - Sempre que houver dados (dadosPreviaPDF.length > 0) E shouldOpenModalRef.current === true,
   *   abrimos o modal, independente de o conteúdo ser igual ao anterior.
   * - Isso garante que versões congeladas (mesmo resumo) possam ser abertas quantas vezes o usuário quiser.
   */
  useEffect(() => {
    if (dadosPreviaPDF && dadosPreviaPDF.length > 0 && modalFlow && shouldOpenModalRef.current) {
      prevDadosPreviaPDFRef.current = dadosPreviaPDF;
      modalRef.current?.abrir();
      shouldOpenModalRef.current = false;
    }
  }, [dadosPreviaPDF, modalFlow]);
  
  // Limpar dados quando o modal fecha para permitir reabrir sem travar estado
  const handleCloseModal = () => {
    modalRef.current?.fechar();
    // Limpar após um pequeno delay para permitir que o modal feche
    setTimeout(() => {
      setDadosPreviaPDF([]);
      shouldOpenModalRef.current = false;
    }, 100);
  };

  useEffect(() => {
    const fetchModalEditar = async () => {
      try {
        const responseCategorias = await buscarCategoriasTributarias();
        setCategorias(
          responseCategorias.categories.map((categoria) => ({
            id: categoria.idCategoriaTributaria,
            label: categoria.descricao,
          }))
        );

        const modalDadosValue = {
          idPreviaInss: data.idPreviaInss,
          categoria: data.categoria,
          dtInicial: data.dtInicial,
          dtFinal: data.dtFinal,
          dtInicioEsocial: data.dtInicioEsocial,
          isCPRB: data.isCPRB,
        };
        setDadosModalEditar(modalDadosValue);
      } catch (error) {
        console.error(error);
      }
    };

    const fetchDatas = async () => {
      try {
        const cnpjLimpo = String(data?.cnpj || "").replace(/\D/g, "");
        if (!cnpjLimpo) return;
        const res = await listarEmpresas({ cnpj: cnpjLimpo });
        const empresas = Array.isArray(res?.data) ? res.data : (Array.isArray(res) ? res : []);
        const empresa = empresas[0];
        const dtAbertura = empresa?.dt_abertura ?? empresa?.data_abertura;
        const simplesDtOpcao = empresa?.simples_dt_opcao;
        const simplesDtExclusao = empresa?.simples_dt_exclusao;
        setInfoHeader({
          dtAbertura: dtAbertura ? formatData(dtAbertura) : "------",
          dtOptionSimples: simplesDtOpcao ? formatData(simplesDtOpcao) : "------",
          dtExclusaoSImples: simplesDtExclusao ? formatData(simplesDtExclusao) : "------",
        });
      } catch (error) {
        // silencioso aqui
      }
    };

    if (modalEditar) fetchModalEditar();
    fetchDatas();
  }, [modalEditar, data]);

  const tabs = useMemo(
    () => [
      { label: "Verbas eSocial", tab: <VerbasEsocial data={data} /> },
      { label: "Ajuste de Verbas", tab: <AjustesVerbas data={data} /> },
      { label: "Relatórios Impostos", tab: <Impostos data={data} /> },
      { label: "Relatório 20s", tab: <Relatorio20s data={data} /> },
      { label: "Análise Completa", tab: <GerarRelatorioCompleto data={data} /> },
    ],
    [data]
  );

  const getResumoFonteAtual = () => {
    const local = JSON.parse(localStorage.getItem("resumoAtual") || "[]");
    if (Array.isArray(local) && local.length > 0) return local;
    if (Array.isArray(dados?.resumoAtual) && dados.resumoAtual.length > 0) return dados.resumoAtual;
    return dados?.resumo || [];
  };

  const handleCategoriaChange = (_value) => {
    // Seleção de categoria agora é gerenciada dentro do modal (estado por verba)
  };

  const onClickGerarPrevia = (e) => {
    e.preventDefault();
    e.stopPropagation();
    // sinaliza que o próximo resultado deve abrir o modal
    shouldOpenModalRef.current = true;
    handleGerarPrevia();
  };

  const handleGerarPrevia = async () => {
    try {
      verbasPayloadRef.current = [];
      let fonteResumo = getResumoFonteAtual();

      const relFilters = (() => {
        try {
          return JSON.parse(localStorage.getItem('relatorioGeralFilters') || '{}');
        } catch {
          return {};
        }
      })();
      const params = {};
      if (relFilters?.inicio) params.inicio = relFilters.inicio;
      if (relFilters?.fim) params.fim = relFilters.fim;
      if (relFilters?.tipoItem) params.tipoItem = relFilters.tipoItem;

      // Se não há resumo carregado, tenta regenerar antes de desistir
      if (!Array.isArray(fonteResumo) || fonteResumo.length === 0) {
        try {
          const regenerado = await handleBuscarResumoGeralVersao();
          if (Array.isArray(regenerado) && regenerado.length > 0) {
            fonteResumo = regenerado;
          }
        } catch (e) {
          console.warn("Tentativa de regenerar resumo falhou:", e);
        }
      }

      const listaVerbasPayload = Array.from(
        new Set(
          (Array.isArray(fonteResumo) ? fonteResumo : [])
            .map(
              (r) =>
                `${(r.codigoRubricaCompleto ?? r.codigoRubrica ?? "").trim()}${(r.descricaoRubrica ?? "").trim()}`
            )
            .filter((s) => s.length > 0)
        )
      );

      localStorage.removeItem("resumoAtual");

      if (listaVerbasPayload.length === 0) {
        const response = await gerarRelatorioPreviaInssConsolidado(dados.idVersao, params);
        const resumoResult = response?.resumo ?? response?.data?.resumo ?? response;
        if (Array.isArray(resumoResult) && resumoResult.length > 0) {
          setDadosPreviaPDF(resumoResult);
          setModalFlow("previa");
        } else {
          setObjSnackBar({
            type: "warning",
            msg: "Nenhuma verba com composição de projeto encontrada para gerar o resumo. Verifique o ajuste de verbas.",
          });
        }
        return;
      }

      const response = await buscarVerbasComCategorias({ verbas: listaVerbasPayload });

      const comCat = new Set(
        (response?.verbasCategorias || []).map((v) => (v.codDescricao || "").trim().toLowerCase())
      );

      const verbasSemCategoria = (fonteResumo || [])
        .filter(
          (r) =>
            !comCat.has(
              `${(r.codigoRubricaCompleto ?? r.codigoRubrica ?? "").trim()}${(r.descricaoRubrica ?? "").trim()}`.toLowerCase()
            )
        )
        .filter((r, i, self) => {
          const k = `${(r.codigoRubricaCompleto ?? r.codigoRubrica ?? "").trim()}${(r.descricaoRubrica ?? "").trim()}`.toLowerCase();
          return i ===
            self.findIndex(
              (x) =>
                `${(x.codigoRubricaCompleto ?? x.codigoRubrica ?? "").trim()}${(x.descricaoRubrica ?? "").trim()}`.toLowerCase() ===
                k
            );
        });

      if (verbasSemCategoria.length > 0) {
        const verbasParaModal = verbasSemCategoria.map((resumo, index) => ({
          id: index + 1,
          codigo: resumo.codigoRubricaCompleto ?? resumo.codigoRubrica,
          descricao: resumo.descricaoRubrica,
        }));

        setVerbasPendentes(verbasParaModal);
        setModalVerbasPendentes(true);
        return;
      }

      const resp = await gerarRelatorioPreviaInssConsolidado(dados.idVersao, params);
      const resumoFinal = resp?.resumo ?? resp?.data?.resumo ?? resp;
      if (Array.isArray(resumoFinal) && resumoFinal.length > 0) {
        setDadosPreviaPDF(resumoFinal);
        setModalFlow("previa");
      } else {
        setObjSnackBar({
          type: "warning",
          msg: "Resumo consolidado retornou vazio. Verifique se as verbas possuem composição de projeto e categorias.",
        });
      }
    } catch (error) {
      console.error("Erro ao gerar prévia:", error);
      setObjSnackBar({
        type: "error",
        msg: error?.response?.data?.mensagem ?? error?.response?.data?.message ?? "Erro ao gerar prévia. Verifique o console.",
      });
    } finally {
      setLoading(false);
    }
  };

  const onClickGerarProjeto = (e) => {
    e.preventDefault();
    e.stopPropagation();
    console.log("🔵 onClickGerarProjeto chamado");
    console.log("dados:", dados);
    console.log("dados.isEditable:", dados?.isEditable);
    handleGerarProjeto();
  };

  const handleGerarProjeto = async () => {
    try {
      shouldOpenModalRef.current = true;
      verbasPayloadRef.current = [];
      let fonteResumo = getResumoFonteAtual();

      const relFiltersProj = (() => {
        try {
          return JSON.parse(localStorage.getItem('relatorioGeralFilters') || '{}');
        } catch {
          return {};
        }
      })();
      const paramsProj = {};
      if (relFiltersProj?.inicio) paramsProj.inicio = relFiltersProj.inicio;
      if (relFiltersProj?.fim) paramsProj.fim = relFiltersProj.fim;
      if (relFiltersProj?.tipoItem) paramsProj.tipoItem = relFiltersProj.tipoItem;

      if (!Array.isArray(fonteResumo) || fonteResumo.length === 0) {
        try {
          const regenerado = await handleBuscarResumoGeralVersao();
          if (Array.isArray(regenerado) && regenerado.length > 0) {
            fonteResumo = regenerado;
          }
        } catch (e) {
          console.warn("Tentativa de regenerar resumo falhou:", e);
        }
      }

      const listaVerbasPayload = Array.from(
        new Set(
          (Array.isArray(fonteResumo) ? fonteResumo : [])
            .map(
              (r) =>
                `${(r.codigoRubricaCompleto ?? r.codigoRubrica ?? "").trim()}${(r.descricaoRubrica ?? "").trim()}`
            )
            .filter((s) => s.length > 0)
        )
      );

      const isProjeto = dados.tipoVersao === 'projeto';

      if (listaVerbasPayload.length === 0) {
        let response;
        if (isProjeto) {
          response = await gerarRelatorioProjetoInssConsolidado(dados.idVersao, paramsProj);
        } else {
          response = await gerarRelatorioPreviaInssConsolidado(dados.idVersao, paramsProj);
        }
        const resumoResult = response?.resumo ?? response?.data?.resumo ?? response;
        if (Array.isArray(resumoResult) && resumoResult.length > 0) {
          setDadosPreviaPDF(resumoResult);
          setModalFlow(isProjeto ? "projeto" : "previa");
        } else {
          setObjSnackBar({
            type: "warning",
            msg: "Nenhuma verba com composição de projeto encontrada para gerar o resumo.",
          });
        }
        return;
      }

      const response = await buscarVerbasComCategorias({ verbas: listaVerbasPayload });

      const comCat = new Set(
        (response?.verbasCategorias || []).map((v) => (v.codDescricao || "").trim().toLowerCase())
      );

      const verbasSemCategoria = (fonteResumo || [])
        .filter(
          (r) =>
            !comCat.has(
              `${(r.codigoRubricaCompleto ?? r.codigoRubrica ?? "").trim()}${(r.descricaoRubrica ?? "").trim()}`.toLowerCase()
            )
        )
        .filter((r, i, self) => {
          const k = `${(r.codigoRubricaCompleto ?? r.codigoRubrica ?? "").trim()}${(r.descricaoRubrica ?? "").trim()}`.toLowerCase();
          return i ===
            self.findIndex(
              (x) =>
                `${(x.codigoRubricaCompleto ?? x.codigoRubrica ?? "").trim()}${(x.descricaoRubrica ?? "").trim()}`.toLowerCase() ===
                k
            );
        });

      if (verbasSemCategoria.length > 0) {
        const verbasParaModal = verbasSemCategoria.map((resumo, index) => ({
          id: index + 1,
          codigo: resumo.codigoRubricaCompleto ?? resumo.codigoRubrica,
          descricao: resumo.descricaoRubrica,
        }));

        setVerbasPendentes(verbasParaModal);
        setModalVerbasPendentes(true);
        return;
      }

      let resp;
      if (isProjeto) {
        resp = await gerarRelatorioProjetoInssConsolidado(dados.idVersao, paramsProj);
      } else {
        resp = await gerarRelatorioPreviaInssConsolidado(dados.idVersao, paramsProj);
      }
      const resumoFinal = resp?.resumo ?? resp?.data?.resumo ?? resp;
      if (Array.isArray(resumoFinal) && resumoFinal.length > 0) {
        setDadosPreviaPDF(resumoFinal);
        setModalFlow(isProjeto ? "projeto" : "previa");
      } else {
        setObjSnackBar({
          type: "warning",
          msg: "Resumo consolidado retornou vazio. Verifique composição de projeto e categorias.",
        });
      }
    } catch (error) {
      console.error("Erro ao gerar projeto:", error);
      setObjSnackBar({
        type: "error",
        msg: error?.response?.data?.mensagem || error?.message || "Erro ao gerar projeto.",
      });
    } finally {
      setLoading(false);
    }
  };

  const steps = [
    "Verbas eSocial",
    "Ajuste de Verbas",
    "Relatórios Impostos",
    "Relatório 20s",
    "Análise Completa",
  ];

  const stepsComponents = useMemo(
    () => [VerbasEsocial, AjustesVerbas, Impostos, Relatorio20s, GerarRelatorioCompleto],
    []
  );

  const handleStep = (step) => {
    if (step >= 0 && step < steps.length) {
      setActiveStep(step);
    } else if (step < 0) {
      closeModal();
    }
  };

  const Campos = () => (
    <div className={styles.infoHeader}>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
        <Typography variant="caption" color="text.secondary">Dt de Abertura</Typography>
        <Typography variant="body2" sx={{ fontWeight: 500 }}>{infoHeader.dtAbertura}</Typography>
      </Box>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
        <Typography variant="caption" color="text.secondary">Dt de Opção Simples</Typography>
        <Typography variant="body2" sx={{ fontWeight: 500 }}>{infoHeader.dtOptionSimples}</Typography>
      </Box>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
        <Typography variant="caption" color="text.secondary">Dt Exclusão Simples Nacional</Typography>
        <Typography variant="body2" sx={{ fontWeight: 500 }}>{infoHeader.dtExclusaoSImples}</Typography>
      </Box>
    </div>
  );

  const buttonCloseStyle = {
    borderColor: "#18316e",
    color: "#18316e",
    transition: "transform 0.3s ease-in-out",
    "&:hover": { transform: "scale(1.1)", border: "1px solid #18316e" },
  };

  const buttonSubmitStyle = {
    backgroundColor: "#18316e",
    transition: "transform 0.3s ease-in-out",
    "&:hover": { backgroundColor: "#18316e", transform: "scale(1.1)" },
  };

  const ROWS_PER_PAGE_VERBAS = 10;

  const ModalVerbasPendentesTableCard = ({ open, onClose, verbas, categorias, onSave }) => {
    const listaVerbas = Array.isArray(verbas) ? verbas : [];
    const [selecoesPorVerba, setSelecoesPorVerba] = useState({});
    const [currentPage, setCurrentPage] = useState(1);

    useEffect(() => {
      if (open) {
        setSelecoesPorVerba({});
        setCurrentPage(1);
      }
    }, [open, listaVerbas.length]);

    const totalPages = Math.max(1, Math.ceil(listaVerbas.length / ROWS_PER_PAGE_VERBAS));
    const start = (currentPage - 1) * ROWS_PER_PAGE_VERBAS;
    const paginatedVerbas = listaVerbas.slice(start, start + ROWS_PER_PAGE_VERBAS);

    const handleCategoriaChangeRow = (rowId, idCategoria, descricaoCategoria) => {
      setSelecoesPorVerba((prev) => ({
        ...prev,
        [rowId]: idCategoria != null ? { idCategoria, descricaoCategoria } : null,
      }));
    };

    const handleSalvar = async () => {
      const selecionadas = listaVerbas
        .filter((v) => selecoesPorVerba[v.id]?.idCategoria != null)
        .map((v) => ({
          codigo: v.codigo,
          descricao: v.descricao,
          idCategoria: selecoesPorVerba[v.id].idCategoria,
        }));

      if (selecionadas.length === 0) {
        setObjSnackBar({ type: "error", msg: "Nenhuma verba com categoria selecionada para salvar." });
        return;
      }

      const cnpjSchema = String(sessionStorage.getItem("cnpjSelecionado") || "").replace(/\D/g, "");
      if (!cnpjSchema) {
        setObjSnackBar({ type: "error", msg: "CNPJ não encontrado para montar o schema." });
        return;
      }
      const schema = `z_${cnpjSchema}`;

      verbasPayloadRef.current = selecionadas.map((item) => ({
        ...item,
        schema,
      }));

      const novaLista = verbasPayloadRef.current.map((item) => ({
        schema: item.schema,
        codigo: item.codigo,
        descricao: item.descricao,
        idCategoria: item.idCategoria,
      }));

      try {
        const response = await salvartVinculoCategoriaVerba({
          listaVerbasClientes: novaLista,
        });

        setModalVerbasPendentes(false);
        setObjSnackBar({ type: "success", msg: response.message });

        onSave?.();
      } catch (error) {
        console.error("Erro ao salvar categorias:", error);
        setObjSnackBar({ type: "error", msg: "Erro ao salvar categorias das verbas." });
      }
    };

    return (
      <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
        <DialogTitle>Verbas sem categoria</DialogTitle>
        <DialogContent dividers style={{ maxHeight: "500px", overflow: "auto" }}>
          {listaVerbas.length === 0 ? (
            <Typography color="textSecondary">Nenhuma verba pendente.</Typography>
          ) : (
            <>
              <table style={{ width: "100%", borderCollapse: "collapse", tableLayout: "fixed" }}>
                <thead>
                  <tr style={{ borderBottom: "2px solid #e0e0e0", textAlign: "left" }}>
                    <th style={{ padding: "8px", width: "20%" }}>Código</th>
                    <th style={{ padding: "8px", width: "40%" }}>Descrição</th>
                    <th style={{ padding: "8px", width: "40%" }}>Categoria</th>
                  </tr>
                </thead>
                <tbody>
                  {paginatedVerbas.map((row) => {
                    const key = row.id;
                    const sel = selecoesPorVerba[key];
                    return (
                      <tr key={key} style={{ borderBottom: "1px solid #eee" }}>
                        <td style={{ padding: "8px", overflow: "hidden", textOverflow: "ellipsis" }}>{row.codigo}</td>
                        <td style={{ padding: "8px", overflow: "hidden", textOverflow: "ellipsis" }}>{row.descricao}</td>
                        <td style={{ padding: "8px" }}>
                          <BasicSelect
                            style={{ width: "100%" }}
                            options={Array.isArray(categorias) ? categorias.map((c) => c.descricao) : []}
                            value={sel?.descricaoCategoria ?? ""}
                            onChange={(e) => {
                              const desc = e.target.value;
                              const cat = (categorias || []).find((c) => c.descricao === desc);
                              handleCategoriaChangeRow(key, cat?.id ?? null, desc || "");
                            }}
                          />
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
              {totalPages > 1 && (
                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mt: 2, px: 1 }}>
                  <Button size="small" disabled={currentPage <= 1} onClick={() => setCurrentPage((p) => p - 1)}>
                    Voltar
                  </Button>
                  <Typography variant="body2" color="textSecondary">
                    Página {currentPage} de {totalPages}
                  </Typography>
                  <Button size="small" disabled={currentPage >= totalPages} onClick={() => setCurrentPage((p) => p + 1)}>
                    Avançar
                  </Button>
                </Box>
              )}
            </>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose}>Cancelar</Button>
          <Button variant="contained" onClick={handleSalvar}>Salvar Categorias</Button>
        </DialogActions>
      </Dialog>
    );
  };

  const onCloseAll = () => {
    try { sessionStorage.removeItem(STORAGE_STEP_KEY); } catch {}
    closeModal();
    navigate("/esocial/previas");
  };

  useEffect(() => {
    const storedMenuItems = localStorage.getItem("itensMenu");
    if (storedMenuItems) {
      setMenuItems(JSON.parse(storedMenuItems));
    }
  }, []);

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  const handleMenuClick = (menuId) => {
    if (openMenus.includes(menuId)) {
      setOpenMenus(openMenus.filter((id) => id !== menuId));
    } else {
      setOpenMenus([menuId]);
    }
  };

  const handleSubmenuClick = (submenu) => {
    navigate(submenu.href);
    setOpen(false);
    setOpenMenus([]);
    closeModal();
  };

  const normaliza = (texto) =>
    texto
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .trim()
      .toLowerCase();

  const ordemManualSubmenu = [
    "PERDCOMP",
    "Extrato",
    "COMP-HOMO",
    "Compensações",
    "INSS",
    "PIS/COFINS",
    "IRPJ-CSLL",
    "ICMS",
    "ISS",
    "Ação Judicial",
    "C.E",
  ];

  const renderSubmenus = (submenus, menuId, menu) => {
    let submenusOrdenados = submenus;

    if (menu === "Conta Corrente") {
      submenusOrdenados = [...submenus].sort((a, b) => {
        const nomeA = normaliza(a.submenu ?? a.descricao ?? "");
        const nomeB = normaliza(b.submenu ?? b.descricao ?? "");

        const indexA = ordemManualSubmenu.findIndex(
          (item) => normaliza(item) === nomeA
        );
        const indexB = ordemManualSubmenu.findIndex(
          (item) => normaliza(item) === nomeB
        );

        return indexA - indexB;
      });
    }

    return (
      <List>
        {submenusOrdenados.map((submenu) => (
          <ListItem key={submenu.idSubMenu} disablePadding>
            <ListItemButton onClick={() => handleSubmenuClick(submenu)}>
              <ListItemText primary={submenu.submenu ?? submenu.descricao} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    );
  };

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      {/* Header */}
      <MuiAppBar
        position="fixed"
        sx={{ 
          backgroundColor: "#18316e",
          zIndex: (theme) => theme.zIndex.drawer + 1
        }}
      >
        <Toolbar
          sx={{
            display: "grid",
            gridGap: 20,
            gridTemplateColumns: "repeat(3, 1fr)",
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: "1rem", justifySelf: "flex-start" }}>
            <IconButton
              color="inherit"
              aria-label="open drawer"
              onClick={handleDrawerOpen}
              sx={{ mr: 1 }}
            >
              <MenuIcon />
            </IconButton>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: '0.5rem', flexWrap: 'nowrap' }}>
              <Typography variant="subtitle1" sx={{ color: 'white', fontWeight: 'bold', whiteSpace: 'nowrap', flexShrink: 0 }}>
                {tabComponent ? 'Projeto INSS' : 'Prévia INSS'}
              </Typography>
              {dados?.isEditable === false && (
                <Typography 
                  variant="caption" 
                  sx={{ 
                    backgroundColor: '#ff9800',
                    color: 'white',
                    padding: '2px 8px',
                    borderRadius: '4px',
                    fontWeight: 'bold',
                    fontSize: '0.7rem',
                    whiteSpace: 'nowrap',
                    flexShrink: 0,
                  }}
                >
                  SOMENTE LEITURA
                </Typography>
              )}
            </Box>
            {data?.razaoSocial && (
              <Tooltip title={`CNPJ: ${data?.cnpj || ''}`} arrow>
                <Typography 
                  variant="body2" 
                  sx={{ 
                    color: 'rgba(255, 255, 255, 0.9)',
                    cursor: 'help',
                    maxWidth: '300px',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap'
                  }}
                >
                  - {data.razaoSocial}
                </Typography>
              </Tooltip>
            )}
          </Box>
          
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              cursor: "pointer",
            }}
            onClick={() => navigate("/dashboard")}
          >
            <img src={logo} alt="Logo" style={{ height: "40px" }} />
          </Box>
          
          <Box
            sx={{
              display: "flex",
              justifySelf: "flex-end",
              alignItems: "center",
            }}
          >
            <IconButton color="inherit" onClick={onCloseAll}>
              <CloseIcon />
            </IconButton>
          </Box>
        </Toolbar>
      </MuiAppBar>

      {/* Menu Lateral */}
      <Drawer
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          "& .MuiDrawer-paper": {
            width: drawerWidth,
            boxSizing: "border-box",
            zIndex: (theme) => theme.zIndex.modal + 2,
          },
        }}
        variant="temporary"
        anchor="left"
        open={open}
        onClose={handleDrawerClose}
        hideBackdrop={true}
        ModalProps={{
          keepMounted: true,
          sx: {
            zIndex: (theme) => theme.zIndex.modal + 1,
          }
        }}
      >
        <DrawerHeader sx={{ backgroundColor: '#18316e', justifyContent: 'space-between', paddingLeft: '16px' }}>
          <Typography sx={{ fontWeight: "bold", color: 'white' }}>
            Menu
          </Typography>
          <IconButton onClick={handleDrawerClose}>
            {theme.direction === "ltr" ? (
              <ChevronLeftIcon sx={{ color: 'white' }} />
            ) : (
              <ChevronRightIcon sx={{ color: 'white' }} />
            )}
          </IconButton>
        </DrawerHeader>
        <Divider />
        <List>
          {menuItems.map((menuItem) => (
            <div key={menuItem.idMenu}>
              <ListItem disablePadding>
                <ListItemButton
                  onClick={() => handleMenuClick(menuItem.idMenu)}
                >
                  <ListItemText
                    primary={menuItem.menu}
                    primaryTypographyProps={{
                      fontWeight: "bold",
                    }}
                  />
                  {openMenus.includes(menuItem.idMenu) ? (
                    <ExpandLess />
                  ) : (
                    <ExpandMore />
                  )}
                </ListItemButton>
              </ListItem>
              <Collapse
                in={openMenus.includes(menuItem.idMenu)}
                timeout="auto"
                unmountOnExit
              >
                {renderSubmenus(
                  menuItem.submenu,
                  menuItem.idMenu,
                  menuItem.menu
                )}
              </Collapse>
            </div>
          ))}
        </List>
      </Drawer>

      {/* Conteúdo Principal */}
      <Box component="main" sx={{ flexGrow: 1, width: '100%' }}>
        <DrawerHeader />
        <div style={{ paddingBottom: "100px" }}>
          {tabComponent ? (
            <TabsGeneric tabs={tabs} complementaryHeader={<Campos />} />
          ) : (
            <StepsGeneric
              steps={steps}
              stepsComponents={stepsComponents}
              data={data}
              activeStep={activeStep}
              setActiveStep={setActiveStep}
              complementaryHeader={<Campos />}
            />
          )}
        </div>
      </Box>

      {/* Botões de Ação Flutuantes */}
      <div className={styles.actionContainer__verbas}>
        <div className={styles.backActions__actionContainer}>
          {dados?.isEditable === false && (
            <Typography 
              variant="body2" 
              sx={{ 
                color: '#ff9800', 
                fontWeight: 'bold',
                display: 'flex',
                alignItems: 'center',
                gap: '0.5rem'
              }}
            >
              ⚠️ Modo Visualização - Versão Antiga (Não Editável)
            </Typography>
          )}
          {!tabComponent ? (
            <>
              {activeStep > 0 ? (
                <Button
                  sx={buttonCloseStyle}
                  variant="outlined"
                  color="primary"
                  type="button"
                  onClick={() => handleStep(activeStep - 1)}
                >
                  Voltar
                </Button>
              ) : (
                <Button
                  sx={buttonCloseStyle}
                  variant="outlined"
                  color="primary"
                  type="button"
                  onClick={() => setModalEditar(true)}
                  disabled={dados?.isEditable === false}
                >
                  Editar Prévia
                </Button>
              )}

              <Button
                sx={buttonCloseStyle}
                variant="outlined"
                color="primary"
                type="button"
                onClick={onCloseAll}
              >
                FECHAR
              </Button>
            </>
          ) : (
            <Button
              sx={buttonCloseStyle}
              variant="outlined"
              color="primary"
              type="button"
              onClick={onCloseAll}
            >
              FECHAR
            </Button>
          )}
        </div>

        {!tabComponent ? (
          <Button
            sx={buttonSubmitStyle}
            variant="contained"
            color="primary"
            type="button"
            onClick={(e) =>
              activeStep + 1 === steps.length ? onClickGerarPrevia(e) : handleStep(activeStep + 1)
            }
            disabled={dados?.isEditable === false}
            startIcon={activeStep + 1 === steps.length ? <AssessmentIcon /> : null}
          >
            {activeStep + 1 === steps.length ? "Resumo" : " Próximo"}
          </Button>
        ) : (
          <Button
            sx={buttonSubmitStyle}
            variant="contained"
            color="primary"
            type="button"
            onClick={onClickGerarProjeto}
          >
            Gerar Projeto
          </Button>
        )}
      </div>

      <ModalEditar
        open={modalEditar}
        onClose={() => setModalEditar(false)}
        dados={dadosModalEditar}
        rechargeData={rechargeData}
        categorias={categorias}
      />

      <ModalVisualizarPreviaPDF
        ref={modalRef}
        dadosPreviaPDF={dadosPreviaPDF}
        flow={modalFlow}
        cnpj={data?.cnpj}
        idPreviaInss={data?.idPreviaInss}
        onClose={handleCloseModal}
        onFecharVersaoAoConfirmar={() => {
          closeModal();
          navigate("/esocial/previas");
        }}
        {...(modalFlow === "projeto"
          ? {
              onEnviar: enviarProjetoInss,
              buildPayload: (base64, dadosContexto) => ({
                idProjetoVersao: dadosContexto.idVersao,
                pdfBase64: base64,
                email: "gustavo.tolentino@taxationmind.com.br",
              }),
            }
          : {})}
      />

      <SnackBar objSnackBar={objSnackBar} setObjSnackBar={setObjSnackBar} />

      <ModalVerbasPendentesTableCard
        open={modalVerbasPendentes}
        onClose={() => setModalVerbasPendentes(false)}
        verbas={verbasPendentes}
        categorias={categoriasVerbas}
        onSave={() => handleGerarProjeto()}
      />
    </Box>
  );
};

export default MainComponente;
